import {type IconProps } from '../iconProps';

export const Inbox: React.FC<IconProps> = ({ size, fill }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H16C16.55 0 17.0208 0.195833 17.4125 0.5875C17.8042 0.979167 18 1.45 18 2V16C18 16.55 17.8042 17.0208 17.4125 17.4125C17.0208 17.8042 16.55 18 16 18H2ZM2 16H16V13H13C12.5 13.6333 11.9042 14.125 11.2125 14.475C10.5208 14.825 9.78333 15 9 15C8.21667 15 7.47917 14.825 6.7875 14.475C6.09583 14.125 5.5 13.6333 5 13H2V16ZM9 13C9.53333 13 10.025 12.8625 10.475 12.5875C10.925 12.3125 11.2917 11.95 11.575 11.5C11.675 11.35 11.8 11.2292 11.95 11.1375C12.1 11.0458 12.2667 11 12.45 11H16V2H2V11H5.55C5.73333 11 5.9 11.0458 6.05 11.1375C6.2 11.2292 6.325 11.35 6.425 11.5C6.70833 11.95 7.075 12.3125 7.525 12.5875C7.975 12.8625 8.46667 13 9 13Z'
        fill={fill}
      />
    </svg>
  );
};
